import React from "react";
import Header from "./Reusables/Header";
import ABMTable from "./Tables/ABMTable";
import DownloadIcon from "@mui/icons-material/Download";
import DownloadImg from "../assests/download.svg";
import AlternateABMTable from "./Tables/AlternateABMTable";
import PeriodSelector from "./PeriodSelector";
const ABMlevelBudget = () => {
  const [selectedScreen, setselectedScreen] = React.useState("");

  const handleChangeScreen = (event) => {
    setselectedScreen(event.target.value)
  }


  return (
    <div className="bg-white home-screen" >
      <div style={{display:"flex"}}>
      <PeriodSelector/>
      
{/*       
      <label style={{fontWeight:"500",marginTop:"16px",marginLeft:"16px"}}>select Level :</label> */}
{/* 
       <select
              className="filter-style"
              id="screen"
              style={{ marginRight: "5px", width: "200px",marginLeft:"10px" ,marginTop:"16px"}}
              onChange={(event) => handleChangeScreen(event)}
              value={selectedScreen}
              
            >
              <option value="abm">ABM level</option>
              <option value="abmrephq">REP HQ level</option>
             
            </select> */}
      </div>
      <ABMTable style={{ marginTop: "20px", marginRight: "10px" }} />
    </div>
  );
};

export default ABMlevelBudget;
